import { createBrowserHistory } from 'history';
import { navActions } from '../_actions';
export const history = createBrowserHistory();

const location = history.location;

history.listen((location, action) => {
  navActions.notify(action, location.pathname);
});
